import './ViewTester.scss';
import { useState, useEffect, useContext } from 'react';
import { reactPlugin } from '../../../../services/appInsights.service';
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { TesterService } from '../../../../services/tester.service';
import { Tester } from '../../../../interfaces/tester.interface';
import { Button } from 'react-bootstrap';
import Spinner from '../../../components/Spinner';
import { UserAuthContext, Authorize } from '../../appLoginComponent/UserAuthContext'
import ErrorComponentModel from '../../appUtilityComponent/ErrorComponentModel/ErrorComponentModel';
import { ComponentModelPopup } from '../../../../interfaces/modal.interface';

import { logOut } from '../../appHeaderComponent/AppHeader';

type TParams = { readonly testerId: number, readonly onEdit: any, readonly onDelete: any };

function ViewTester({ testerId, onEdit, onDelete }: TParams) {

  const { isAuthorized } = useContext(UserAuthContext) as Authorize;

  const [tester, setTester] = useState({} as Tester);

  const [isShowLoading, setIsShowLoading] = useState(false as boolean);

  const [isCommentExpended, setIsCommentExpended] = useState(false as boolean);

  const [errorModal, setErrorModal] = useState({
    Title: "Error",
    Show: false,
    Component: null,
    HandleClose: () => setErrorModal((prev) => ({ ...prev, Show: false }))
  } as ComponentModelPopup);

  const closeErrorModal = () => setErrorModal((prev) => ({ ...prev, Show: false }));

  const extractMessage = (source: any, fallback: string) =>
    source?.statusMessage?.statusMessage ||
    source?.response?.data?.statusMessage ||
    source?.message ||
    fallback;
  const showErrorModal = (message: string) =>
    setErrorModal({
      Title: "Error",
      Show: true,
      Component: <div>{message}</div>,
      HandleClose: closeErrorModal
    });

  useEffect(() => {

    setIsShowLoading(true);

    setTester({} as Tester);

    const testerService = new TesterService();

    testerService.GetTesterById(testerId).then(response => {
      console.log(response, "api response")
      if (response.statusCode === "N") {
        const errorMessage = extractMessage(response, "Failed to load tester information");
        console.error("GetTesterById error:", errorMessage);
        setErrorModal({
          Title: "Error",
          Show: true,
          Component: <div>{errorMessage}</div>,
          HandleClose: logOut,
          HandleOk: logOut
        });
        setIsShowLoading(false);
        return;
      }

      const _tester = response.result;

      if (!_tester) {
        const errorMessage = "No tester data returned from server";
        showErrorModal(errorMessage);
        setIsShowLoading(false);
        return;
      }

      _tester.mailingAddrstateCD = _tester.mailingAddrstateCD.trim();

      if (_tester.testerContacts.length > 0) {
        _tester.pocName = _tester.testerContacts[0].pocName;
        _tester.pocPhone = _tester.testerContacts[0].pocPhone;
        _tester.pocEmail = _tester.testerContacts[0].pocEmail;
        _tester.pocTitle = _tester.testerContacts[0].pocTitle;
      }

      setTester(_tester);
      setIsShowLoading(false);
    }).catch((error) => {
      const message = extractMessage(error, "An unexpected error occurred while loading tester information. Please try again.");
      console.error("GetTesterById exception:", error);
      showErrorModal(message);
      setIsShowLoading(false);
    });
  }, [testerId]);

  const formatPhoneNumber = (phoneNumberString: string) => {
    if (!phoneNumberString) return "";
    const cleaned = ('' + phoneNumberString).replaceAll(/\D/g, '');
    const match = /^(\d{3})(\d{3})(\d{4})$/.exec(cleaned);
    if (match) {
      return '(' + match[1] + ') ' + match[2] + '-' + match[3];
    }
    return phoneNumberString;
  }

  return (
    <>
      <ErrorComponentModel modal={errorModal} />
      {!!tester.testerId && (
        <div className="row pt-2 pb-2">
          <div className="col-sm-12">
            <dl className="row">
              <div className="col-md-6 col-sm-12 pb-1 pt-1">
                <dt>Tester</dt>
                <dd>{tester.testerName}</dd>
              </div>
              <div className="col-md-3 col-sm-12 pb-1 pt-1">
                <dt>Tester ID</dt>
                <dd>{tester.testerId}</dd>
              </div>
              <div className="col-md-3 col-sm-12 pb-1 pt-1">
                <dt>Contact Number</dt>
                <dd>{formatPhoneNumber(tester.pocPhone)}</dd>
              </div>
              <div className="col-md-6 col-sm-12 pb-1 pt-1">
                <dt>Address</dt>
                <dd>{tester.physicalAddrLine1} {tester.physicalAddrLine2} {tester.physicalAddrCity}, {tester.physicalAddrstateCD} {tester.physicalAddrZip}</dd>
              </div>

              <div className="col-md-6 col-sm-12 pb-1 pt-1">
                <dt>Mailing Address</dt>
                <dd>{((tester.mailingAddrLine1 + tester.mailingAddrLine2 + tester.mailingAddrCity + tester.mailingAddrstateCD + tester.mailingAddrZip).length > 0) ? (tester.mailingAddrLine1 + " " + tester.mailingAddrLine2 + " " + tester.mailingAddrCity + ", " + tester.mailingAddrstateCD + " " + tester.mailingAddrZip) : "- - - - -"}</dd>
              </div>

              <div className="col-md-6 col-sm-12 pb-1 pt-1">
                <dt>Principal Point of Contact - Title</dt>
                <dd>{tester.pocName} - {tester.pocTitle}</dd>
              </div>
              <div className="col-md-3 col-sm-12 pb-1 pt-1">
                <dt>Email</dt>
                <dd>{tester.pocEmail}</dd>
              </div>

              <div className="col-sm-12 pb-1 pt-1">
                <dt>comment</dt>
                <dd>{(tester.comment && tester.comment.length > 0) ?
                  <>
                    {tester.comment.length > 50 ?
                      <>
                        {isCommentExpended ?
                          <>
                            {tester.comment + ". "}
                            <Button size="sm" variant="link" onClick={() => { setIsCommentExpended(false) }} className="read-less">read less</Button>
                          </> :
                          <>
                            {tester.comment.substring(0, 50) + "...  "}
                            <Button size="sm" variant="link outline-light" onClick={() => { setIsCommentExpended(true) }} className="read-more">read more</Button>
                          </>
                        }
                      </>
                      : tester.comment}
                  </>

                  : "- - - - -"}</dd>
              </div>
            </dl>
          </div>
          <div className="col-sm-12 text-left">
            <Button className="cursor-shadow-sm btn-default me-3 btn-edit" variant="light" onClick={onEdit}>EDIT TESTER INFORMATION</Button>
            <Button disabled={!isAuthorized("AV_Delete_Tester")} className="cursor-shadow-sm btn-default btn-delete" variant="light" onClick={() => { onDelete(tester) }}>DELETE TESTER</Button>
          </div>
        </div>
      )}
      {isShowLoading && <Spinner></Spinner>}
    </>
  );
}

export default withAITracking(reactPlugin, ViewTester);